<template>
  <div class="error-info flex-row" v-on="$listeners">
    <div class="error-info__index flex-centering">
      {{ index + 1 }}
    </div>
    <div class="flex-1 flex-column">
      <div v-if="error.description" class="text-h4">{{ error.description }}</div>
      <div class="error-info__location">
        <span v-if="error.sheet">{{ $t('Local estimate') }}: {{ error.sheet }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ErrorInfo',
    props: {
      error: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .error-info {
    padding: 12px 20px;
    border: 1px solid $grey200;
    border-radius: 8px;

    &:hover {
      cursor: pointer;
      background-color: $grey50;
    }

    &__index {
      margin-right: 16px;
    }

    &__location {
      color: $text-secondary;
      font-weight: 500;
    }
  }
</style>
